import { KeyboardEvent, useEffect, useState } from "react"
import { Plugin } from "./types"
import { Unit } from "../types"
import { all as lineBreakAllStrategy } from "./useLinebreak"
import { soundboard } from "../.."

type PluginProps = {
    cursorSpeed?: number
    prefix?: Unit[]
    onSubmit?: (command: string) => void
    onEmptySubmit?: () => void
}

const useCLI = ({
    cursorSpeed = 1,
    prefix = ['>', ' '],
    onSubmit = () => { },
    onEmptySubmit = () => { },
}: PluginProps = {}): Plugin => {
    const [cliInputState, setCliInputState] = useState<{ command: string, position: number }>({ command: '', position: 0 })
    const [commandHistory, setCommandHistory] = useState<string[]>([])

    const getCursorCharacter = (fill: Unit = ' ') => [
        ...Array(Math.floor(5 * cursorSpeed)).fill('_'),
        ...Array(Math.floor(5 * cursorSpeed)).fill(fill),
    ]

    const plugin: Plugin = (input, tick, resolution) => {
        let newInput = [...input]
        setCliInputState(current => {
            let relativePosition = prefix.length + (current.position < 0 ? 0 : current.position) + 1
            let cli: Unit[] = [...prefix, ...current.command.split(''),]
            cli.splice(relativePosition, 1, getCursorCharacter(cli[relativePosition]))

            lineBreakAllStrategy([cli], resolution).forEach((row) => {
                newInput.push(row)
            })
            return current
        })

        return newInput
    }

    useEffect(() => {
        if (cliInputState.command !== '') {
            switch (Math.floor(Math.random() * 3)) {
                case 0:
                    soundboard.typewrite1()
                    break;
                case 1:
                    soundboard.typewrite2()
                    break;
                case 2:
                case 3:
                    soundboard.typewrite3()
                    break;
            }

        }
    }, [cliInputState.command])

    

    useEffect(() => {

        const onKeyDown = (event: Event) => {
            const keyDownEvent = event as unknown as KeyboardEvent<Document>
    
            // Lets handle keydown actions async to get a second draw cycle
            // Feels less flickery
            setTimeout(() => {
                if (keyDownEvent.key === "ArrowUp") {
                    setCommandHistory((stack) => {
                        if (stack.length === 0) return stack
    
                        setCliInputState({
                            command: stack.reverse()[0],
                            position: stack.reverse()[0].length,
                        })
    
                        return stack
                    })
                    
    
                } else if (keyDownEvent.key === "Enter") {
                    setCliInputState(currentState => {
                        if (currentState.command === '') {
                            onEmptySubmit()
                        } else {
                            setCommandHistory(stack => [...stack, currentState.command])
                            onSubmit(currentState.command)
                            setCliInputState({
                                command: '',
                                position: 0
                            })
                        }
                        return { command: '', position: 0 }
                    })
                } else if (keyDownEvent.key === "Backspace") {
                    setCliInputState(currentState => {
                        if (currentState.position <= 0 || currentState.command.length <= 0) {
                            return currentState
                        }
                        return {
                            ...currentState,
                            position: currentState.position - 1,
                            command: currentState.command.slice(0, currentState.command.length - 1),
                        }
                    })
                } else if (/[a-zA-Z0-9-_ ?]/.test(keyDownEvent.key) && keyDownEvent.key.length === 1) {
                    setCliInputState(currentState => {
                        return {
                            ...currentState,
                            position: currentState.position + keyDownEvent.key.length,
                            command: currentState.command + keyDownEvent.key,
                        }
                    })
                }
            })
    
        }
        
        if (document.activeElement === document.body) {
            document.addEventListener('keydown', onKeyDown)
        }

        return () => {
            document.removeEventListener('keydown', onKeyDown)
        }

    }, [document.activeElement])



    return plugin
}

export default useCLI